/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ServerIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 88 88"
    onClick={props.onClick}
  >
    <g strokeWidth="2.5" transform="translate(2 2)">
      <path d="M84 24c0 2.204-1.788 4-4 4H4c-2.212 0-4-1.796-4-4V4c0-2.208 1.788-4 4-4h76c2.212 0 4 1.792 4 4v20zM30 20h40M30 12h40" />
      <circle cx="14" cy="14" r="4" fill="none" />
      <path d="M84 52c0 2.204-1.788 4-4 4H4c-2.212 0-4-1.796-4-4V32c0-2.208 1.788-4 4-4h76c2.212 0 4 1.792 4 4v20zM30 48h40M30 40h40" />
      <circle cx="14" cy="42" r="4" fill="none" />
      <path d="M84 80c0 2.204-1.788 4-4 4H4c-2.212 0-4-1.796-4-4V60c0-2.208 1.788-4 4-4h76c2.212 0 4 1.792 4 4v20zM30 76h40M30 68h40" />
      <circle cx="14" cy="70" r="4" fill="none" />
    </g>
  </svg>
);

export default ServerIcon;
